import PropTypes from 'prop-types';

import {
  isNodeEmpty,
  Placeholder,
  UNORDERED_LIST_DEFINITIONS,
} from '@xing-com/content-editor-plugin-helpers';

import { UNORDERED_LIST_TAG_NAME } from './constants';

const UnorderedList = ({
  className,
  UNORDERED_LIST_TAG = UNORDERED_LIST_TAG_NAME,
  ...attributes
}) => {
  const RenderLeaf = ({
    children,
    element,
    attributes: elementAttributes,
  } = {}) => {
    if (element.type === UNORDERED_LIST_DEFINITIONS.type) {
      const { placeholder, ...restOfAttributes } = attributes;

      if (placeholder && isNodeEmpty(element)) {
        return (
          <UNORDERED_LIST_TAG {...elementAttributes}>
            {Placeholder(children, className, placeholder)}
          </UNORDERED_LIST_TAG>
        );
      }

      return (
        <UNORDERED_LIST_TAG
          {...restOfAttributes}
          {...elementAttributes}
          data-editor-plugin={UNORDERED_LIST_DEFINITIONS.type}
          className={className}
        >
          {children}
        </UNORDERED_LIST_TAG>
      );
    }
  };
  return RenderLeaf;
};

UnorderedList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  UNORDERED_LIST_TAG: PropTypes.node,
};

export { UnorderedList };
